export default __webpack_public_path__ + "assets/images/7a2c0833dba101209309b93df7a95d59.svg";